// src/features/medicine-inventory/pages/StockMovements.jsx
import React from 'react';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import StockMovementList from '../components/stock/StockMovementList';

const StockMovements = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* <Navbar /> */}
      <div className="flex">
        {/* <Sidebar /> */}
        <main className="flex-1 p-6">
          <StockMovementList />
        </main>
      </div>
    </div>
  );
};

export default StockMovements;